export const ADD_SCORE = 'ADD_SCORE';
export const UPDATE_PIC = 'UPDATE_PIC';
export const UPDATE_SCORES = 'UPDATE_SCORES';
export const UPDATE_KEY = 'UPDATE_KEY'
export const RETURNING_PLAYER = 'RETURNING_PLAYER'
